module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d6e170r535"
    }
  }, [_c('b', [_vm._v("Acknowledgments ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e2485"
    }
  }, [_c('i', [_vm._v("My earnest thanks to Barb Doyen of Doyen Literary Services, ")]), _c('i', [_vm._v("Karen MacDowall Jones, Steve Spearman, Brian Epps, Leo Borges, ")]), _c('i', [_vm._v("Tina Eliopulos, Todd Moffett, Lynn Forkos, Debi McCandrew, Bill Clayton, ")]), _c('i', [_vm._v("Meg Galliano, Dr. James Williamson, Dr. Charles Mosely, Dr. Don Smith, ")]), _c('i', [_vm._v("Dr. Robert Palinchak, and Dr. Ron Remington.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ada7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sher_9781440522697_epub_c6_r1.vue
// module id = 75
// module chunks = 0